export default "__VITE_ASSET__CuxKZakm__"